import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background: rgba(138, 83, 226, 0.1);
    border-radius: 10px;
    margin-top: auto;
    margin-bottom: 23px;
  .text {
    margin-top: 10px;
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #8A53E1;
  }
`;

export default Wrapper;